module.exports = __webpack_public_path__ + "img/Economic model.a77017c6.svg";